import React from 'react';
import '../../tailwind.css';
import { IExportButton } from '../../types/ExportButton.types';
import { IonButton } from '@ionic/react';

const ExportButton: React.FC<IExportButton> = (props) => {
  return (
    <IonButton
      className="h-50px !max-w-export-button w-full shrink-0 text-white button text-default leading-default text-center tracking-default font-bold"
      disabled={props.disabled}
      mode="ios"
      onClick={props.onClick}>
      {props.children}
    </IonButton>
  );
};

export default ExportButton;
